module.exports = __webpack_public_path__ + "img/n4.3d2aa6ca.png";